import React from "react";
import moment from "moment";

import FIELDERS_TERMS_HTM from "../../assets/cds_terms.htm";
import LYSAGHT_TERMS_HTM from "../../assets/lysaght_terms.htm";

function daysPassed({ date }) {
    var date1 = moment(date, "DD/MM/YYYY");
    var today = moment();
    return today.diff(date1, "days");
}

function updateAgreementDate({ config, user, renew_date, dispatch, saveUserToWeb, addHistory }) {
    if (config?.license_agreement) {
        let accepted_history = [];

        if (
            user?.license_agreement &&
            user?.license_agreement[window.brand] &&
            user?.license_agreement[window.brand].history
        ) {
            accepted_history = user?.license_agreement[window.brand]?.history;
        }

        if (addHistory) {
            accepted_history.push({ accepted_on: moment(new Date()).format("LLLL") });
        }

        let newAgreement = {
            [window.brand]: {
                start_agreement_date: config?.license_agreement?.start_agreement_date,
                renew_date: renew_date ?? config?.license_agreement?.start_agreement_date,
                history: accepted_history,
            },
        };

        let newUser = user;
        newUser["license_agreement"] = newAgreement;
        return dispatch(saveUserToWeb(newUser, true, false)); // Update new agreement date for user
    }
}

function getDateAfter({ days }) {
    var date1 = moment(new Date(), "DD/MM/YYYY"); // get current day
    var newDate = date1.add(days, "days"); // add X days to current date
    return newDate.format("DD/MM/YYYY");
}

// Renew License Agreement
export const updateRenewDate = ({ agreement, config, user, dispatch, saveUserToWeb, addHistory }) => {
    // Get the new renew date from the config "renew_after_days" and current date
    let renew_date = getDateAfter({
        // date: agreement[window.brand].renew_date,
        days: config?.license_agreement?.renew_after_days,
    });
    return updateAgreementDate({
        config,
        user,
        renew_date,
        dispatch,
        saveUserToWeb,
        addHistory,
    });
};

export const TermsModalContent = () => {
    const [htmlContent, setHtmlContent] = React.useState("");
    const iframeRef = React.useRef();

    React.useEffect(() => {
        let TERMS_HTM = window.brand === "Fielders" ? FIELDERS_TERMS_HTM : LYSAGHT_TERMS_HTM;
        fetch(TERMS_HTM)
            .then((response) => response.text())
            .then((html) => {
                const blob = new Blob([html], { type: "text/html;charset=UTF-8" });
                const blobUrl = URL.createObjectURL(blob);
                setHtmlContent(blobUrl);
            })
            .catch((error) => {
                console.error("Error fetching HTML content:", error);
            });
    }, []);

    const onIframeLoad = () => {
        const iframe = iframeRef.current;
        if (iframe) {
            const iframeDocument = iframe.contentWindow.document;
            iframe.height = iframeDocument.body.scrollHeight + "px";
        }
    };

    return (
        <div>
            <iframe
                ref={iframeRef}
                title="HTML Content"
                src={htmlContent}
                onLoad={onIframeLoad}
                scrolling="no"
                style={{ width: "100%", border: "none", backgroundColor: "#f3f3f3" }}
            />
        </div>
    );
};

const TermsConditions = ({ logged_user_code, user, agreement, config, dispatch, saveUserToWeb, setLicenseOpen }) => {
    // // Check License Agreement
    React.useEffect(() => {
        if (logged_user_code && user) {
            if (!agreement) {
                // No License - add license to user
                updateAgreementDate({ config, user, dispatch, saveUserToWeb });
            } else if (agreement !== (undefined || null) && agreement[window.brand]) {
                // Check if start date was changed (this will reset the agreement to that date)
                if (agreement[window.brand]?.start_agreement_date !== config?.license_agreement?.start_agreement_date) {
                    updateAgreementDate({ config, user, dispatch, saveUserToWeb });
                }
                // Check validity - if renew date from today is > renew after total days

                if (daysPassed({ date: agreement[window.brand]?.renew_date }) >= 0) {
                    setLicenseOpen(true);
                }
            }
        }
    }, [user, logged_user_code, config, agreement, dispatch, saveUserToWeb, setLicenseOpen]);
};

export default TermsConditions;
